<template>
  <div class="pa-connection-pod-message-list-wrapper">
    <template v-if="isShowNoPodMessage">
      <PodMessageNoMessageView :isOpen="isShowNoPodMessage" />
    </template>
    <template v-else>
      <ul class="pa-connection-pod-message-list">
        <li v-for="message in targetRoomMessageList" :key="message.id">
          <PodMessage :id="message.id" />
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import PodMessageNoMessageView  from '@/components/Pages/Connections/ConnectionApp/components/PodRoomListView/Parts/PodMessageNoMessageView.vue'
import PodMessage               from '@/components/Pages/Connections/ConnectionApp/components/PodMessage/PodMessage.vue'
export default {
  props : {
    room : {
      default: null
    }
  },

  components : {
    PodMessage,
    PodMessageNoMessageView
  },

  data(){
    return {
      isLoaded              : false,
      targetRoomMessageList : [],
      isShowNoPodMessage    : false,
    };
  },

  computed : {
    podRooms(){
     return this.$store.state.connection.podRooms;
    },

    podRoomType(){
      return this.$store.state.connection.podRoomType;
    }
  },

  watch : {
    // isShowNoPodMessage(value){
    //   console.log(value);
    // },
    room : {
      handler(data){
        if(data === null) return;

        this.setPodRoomMessageList();
      },
      immediate: true
    },

    podRooms : {
      handler(){
        this.setPodRoomMessageList();
      },
      deep:true
    },

    isLoaded : {
      handler(){
        this.checkIsShowNoPodMessage();
      },
      immediate: true
    },

    targetRoomMessageList : {
      handler(){
        this.checkIsShowNoPodMessage();
      },
      immediate: true,
      deep: true
    }
  },

  methods : {
    checkIsShowNoPodMessage(){
      // console.log(this.isLoaded);
      // console.log(this.targetRoomMessageList.length);
      if(this.isLoaded && (this.targetRoomMessageList.length === 0)){
        this.isShowNoPodMessage = true;
      }else{
        this.isShowNoPodMessage = false;
      }
      // console.log(this.isShowNoPodMessage);
    },

    setPodRoomMessageList(){
      if(typeof this.podRoomType === 'undefined') return;

      for(let i = 0; i < this.podRooms[this.podRoomType].length; i++){
        if(this.podRooms[this.podRoomType][i].id === this.room.id){
          this.isLoaded               = this.podRooms[this.podRoomType][i].loaded;
          this.targetRoomMessageList  = this.podRooms[this.podRoomType][i].list;
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-connection-pod-message-list{
  width:98%;
  margin:.7rem auto 1rem;

  li{
    margin-bottom:1rem;

    @media screen and (min-width: $desktop) {
      margin-bottom:1rem;
    }
  }
}
</style>